import styled from '@emotion/styled'

const StyledUserInfoContent = styled.div`
  ${({ style }) => {
    return { ...style }
  }}
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  p {
    margin: 0;
  }
  position: relative;
  .drop-info {
    cursor: pointer;
    min-width: 280px;
    max-width: 280px;
    position: absolute;
    top: ${({ position }) => {
      return position === 'bottom' && `100%`
    }};
    left: ${({ position }) => {
      return position === 'right' && '100%'
    }};
    bottom: ${({ position }) => {
      return position === 'right' && 0
    }};
    right: ${({ position }) => {
      return position === 'bottom' && 0
    }};
    z-index: 100;
    background: #fff;
    overflow: hidden;
    border: 1px solid #e5e9f2;
    box-shadow: 0 3px 12px 1px rgb(44 55 130 / 15%);
    border-radius: 4px;
    .drop-user {
      padding: 18px;
      display: flex;
      .user-text {
        margin-left: 16px;
        .name {
          color: #364a63;
          font-size: 14px;
          font-weight: 700;
        }
        .email {
          color: #8094ae;
          font-size: 12px;
        }
      }
    }
    .drop-exit {
      cursor: pointer;
      border-top: 1px solid #e5e9f2;
      padding: 16px 28px;
      display: flex;
      align-items: center;
      span {
        margin-left: 8px;
        font-size: 14px;
        font-weight: bold;
        color: #526484;
      }
    }
  }
`
export { StyledUserInfoContent }
